import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import Swipeable from 'react-swipeable'
import '../styles/css/VideoPlayer.css'

export default class VideoPlayer extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            videos: [],
            currentVideo: 0
        }
    }

    componentDidMount = () => {
        const { videos, currentVideo } = this.props
        this.setState({
            videos,
            currentVideo
        })
        window.addEventListener("keydown", this.handleKey, true);
        document.body.addEventListener('touchmove', this.preventDefault, { passive: false });
    }

    componentWillUnmount = () => {
        window.removeEventListener("keydown", this.handleKey);
        document.body.removeEventListener('touchmove', this.preventDefault, { passive: false });
    }

    nextVideo = () => {
        const { videos, currentVideo } = this.state
        this.setState({
            currentVideo: currentVideo < videos.length - 1 ? currentVideo + 1 : 0,
            loading: true
        })
    }

    prevVideo = () => {
        const { videos, currentVideo } = this.state
        this.setState({
            currentVideo: currentVideo > 0 ? currentVideo - 1 : videos.length - 1,
            loading: true
        })
    }

    handleKey = ({ keyCode }) => {
        if(keyCode === 39) {
            this.nextVideo()
        } else if(keyCode === 37) {
            this.prevVideo()
        } else if(keyCode === 27) {
            this.onCancel()
        }
    }

    onCancel = () => {
        this.props.onCancel()
    }

    onReady = () => {
        this.setState({
            loading: false
        })
    }

    preventDefault = e => {
        e.preventDefault()
    }

    render() {
        const { videos, currentVideo, loading } = this.state
        return(
            <div id="videoPlayer" className="video-player" onKeyDown={this.handleKey} tabIndex="0">
                <div className="video-player-inner">
                    <div className="video-player-content">

                        <button className="close" onClick={this.onCancel}><span></span><span></span></button>
                        <button className="nav prev" onClick={this.prevVideo}></button>
                        <button className="nav next" onClick={this.nextVideo}></button>

                            <div className="video-container">
                                <Swipeable onSwipedLeft={this.nextVideo} onSwipedRight={this.prevVideo} trackMouse>
                                    {loading && <div className="loader"></div>}
                                    {videos[currentVideo] && 
                                        <ReactPlayer
                                            className={loading ? 'reactplayer hide-video' : 'reactplayer'} 
                                            url={`https://vimeo.com/${videos[currentVideo].id}`}
                                            style={{display: 'block', margin: '0 auto'}}
                                            onReady={this.onReady}
                                            volume={0.75}
                                            playing
                                            config={{
                                                vimeo: {
                                                    playerOptions: {
                                                        autoplay: true,
                                                        loop: true
                                                    }
                                                }
                                            }}
                                        />}
                                </Swipeable>
                            </div> 

                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js